/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../bank-accounts/bank_accounts';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "ExternalBankAccount": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "customerId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "accountNumberSuffix": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "accountType": {
                        "type": "squareup.bank_accounts.BankAccountType",
                        "id": 4,
                        "rule": "optional"
                      },
                      "primaryBankIdentificationNumber": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "verificationStatus": {
                        "type": "squareup.sfs.external.models.ExternalBankAccount.VerificationStatus",
                        "id": 6,
                        "rule": "optional"
                      },
                      "unlinked": {
                        "type": "bool",
                        "id": 7,
                        "rule": "optional"
                      },
                      "creditable": {
                        "type": "bool",
                        "id": 8,
                        "rule": "optional"
                      },
                      "debitable": {
                        "type": "bool",
                        "id": 9,
                        "rule": "optional"
                      },
                      "bankName": {
                        "type": "string",
                        "id": 10,
                        "rule": "optional"
                      },
                      "lastUsedAt": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      },
                      "linked": {
                        "type": "bool",
                        "id": 12,
                        "rule": "optional"
                      },
                      "linkStatus": {
                        "type": "squareup.sfs.external.models.ExternalBankAccount.LinkStatus",
                        "id": 13,
                        "rule": "optional"
                      },
                      "initiatedLinkAt": {
                        "type": "string",
                        "id": 14,
                        "rule": "optional"
                      },
                      "transactionBlockers": {
                        "type": "squareup.bank_accounts.TransactionBlocker",
                        "id": 15,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "VerificationStatus": {
                        "values": {
                          "VERIFICATION_STATUS_DO_NOT_USE": 0,
                          "IN_PROGRESS": 1,
                          "VERIFIED": 2,
                          "FAILED": 3
                        }
                      },
                      "LinkStatus": {
                        "values": {
                          "LINK_STATUS_DO_NOT_USE": 0,
                          "LINKED": 1,
                          "VERIFYING": 2,
                          "UNLINKED": 3
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ExternalBankAccount && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ExternalBankAccount?.nested?.VerificationStatus && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ExternalBankAccount?.nested?.LinkStatus) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a non-SFS Bank Account that has been linked by an SFS Customer to move funds to and from their * SFS account(s)
 * --
 *
 * SOURCE ExternalBankAccount @ squareup/sfs/external/models/external_bank_account.proto at 12:1
 */
export const ExternalBankAccount = $root.lookupType('squareup.sfs.external.models.ExternalBankAccount');
fixType(ExternalBankAccount, {
  id: {
    required: true
  },
  customerId: {
    required: true
  },
  accountNumberSuffix: {
    notEmpty: true
  },
  accountType: {
    required: true
  },
  primaryBankIdentificationNumber: {
    required: true
  },
  verificationStatus: {
    required: true
  },
  creditable: {
    required: true
  },
  debitable: {
    required: true
  },
  linkStatus: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalBankAccount);
/**
 * SOURCE VerificationStatus @ squareup/sfs/external/models/external_bank_account.proto at 13:3
 */
ExternalBankAccount.VerificationStatus = $root.lookupEnum('squareup.sfs.external.models.ExternalBankAccount.VerificationStatus').values;
/**
 * SOURCE LinkStatus @ squareup/sfs/external/models/external_bank_account.proto at 20:3
 */
ExternalBankAccount.LinkStatus = $root.lookupEnum('squareup.sfs.external.models.ExternalBankAccount.LinkStatus').values;